import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { shouldStartClientSentry } from './utils/client-monitoring.ts'

// Never on the public Lowe's form: see shouldStartClientSentry.
if (shouldStartClientSentry(ENV, window.location.pathname)) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
